import { WALLETS } from 'data/supportedWallet';

interface Network {
	name: string;
	image: string;
	value: string;
}

export interface TotalTvl {
	month: string;
	Value: number;
}

export interface Exchanger {
	name: string;
	image: string;
	value: string;
	estApy: string;
	totalUSDC: number | string;
	totalTvl: TotalTvl[];
	network?: Network[];
	aptosContractAddress?: string;
	tvl?: string;
	depositDisabled?: boolean;
	contractAddress?: string;
}

export interface Vault {
	id: number;
	name: string;
	estApy: string;
	currency: string;
	type: string;
	shortDescription: string;
	logo: string;
	darkLogo: string;
	exchanger: Exchanger[];
	token: {
		name: string;
		icon: string;
		alt: string;
		address: string;
		decimalValue: number;
		maxAllowed: number;
		minAllowed: number;
	}[];
	isActive: boolean;
	wallets: WALLETS[];
}

// Define the data using the defined types
export const VAULTS: { [keys: string]: Vault[] } = {
	'Move-Mainnet': [
		{
			id: 0,
			name: 'Atlas',
			currency: 'MOVE',
			type: 'Earn Max points with high capital efficiency', // "High-Risk, High-Reward",
			shortDescription: 'Marketmaking agent',
			logo: '/images/atlas-brand.png',
			darkLogo: '/images/Atlas-white.png',
			estApy: '28%',
			exchanger: [
				{
					name: 'Movement-labs',
					value: 'Movement-labs',
					image: '/crypto/movement.svg',
					estApy: '28%',
					totalUSDC: '200m',
					tvl: '400k',
					contractAddress:
						'0xdda6afe1b6611d7991c4b3b55b35120877a25415e72939516281cf1352863503', //'0xdda6afe1b6611d7991c4b3b55b35120877a25415e72939516281cf1352863503',
					totalTvl: [
						{ month: 'Dec', Value: 0.1 },
						{ month: 'Jan', Value: 0.4 },
						{ month: 'Feb', Value: 1 },
						{ month: 'Mar', Value: 10 },
						{ month: 'Apr', Value: 30 },
						{ month: 'May', Value: 50 },
						{ month: 'June', Value: 82 },
						{ month: 'July', Value: 110 },
						{ month: 'Aug', Value: 1400 },
					],
					depositDisabled: false,
					network: [
						{
							name: 'Move',
							value: 'move',
							image: '/crypto/movement.svg',
						},
					],
				},
			],
			token: [
				{
					address: '0x3073f7aaa4db83f95e9fff17424f71d4751a3073', // 0x833589fcd6edb6e08f4c7c32d4f71b54bda02913 //'0x846B2EaEC7D9A21cf073F4dDa79C6aEa0919c867',
					decimalValue: 6,
					maxAllowed: 100000000,
					name: 'MOVE',
					icon: 'crypto/movement.svg',
					alt: 'MOVE',
					minAllowed: 25, //1000,
				},
			],
			isActive: true,
			wallets: [WALLETS.razor, WALLETS.nightly, WALLETS.okx],
		},
	],
};
